import React from 'react'
import { withStyles } from '@material-ui/styles'

import { Form, Row, Col } from 'reactstrap'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { localized } from 'decorators'
import { createImageUrl } from 'utils/imageUtilities'
import { styles } from './index.css'

export class ImageDialog extends DialogBase {
  modalSize () { return dialogSizes.XL }
  modalTitle () { return this.props.localize('common.imageDetailTitle') }
  modalBody () {
    const { context, classes } = this.props
    return (
      <Form>
        <Row>
          <Col sm='12'>
            <div className={classes.root}>
              <img src={createImageUrl(context.id)} alt={''} />
            </div>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default withStyles(styles)(localized(ImageDialog))
